import { FETCH_MASTER_MAPPING_REQUEST, FETCH_MASTER_MAPPING_SUCCESS, FETCH_MASTER_MAPPING_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: [],
    error: '',
};

const masterMappingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MASTER_MAPPING_REQUEST:
            return { ...state, loading: true };
        case FETCH_MASTER_MAPPING_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_MASTER_MAPPING_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default masterMappingReducer;
